import bgImg from '@/assets/img/curved-images/top_bg.svg';
import { ApiErrorMessages } from '@/components/element/ApiErrorMessages';
import { MyProfileMenuButtonGroup } from '@/components/features/MyProfileMenuButtonGroup';
import { HomeLayout } from '@/components/layout/HomeLayout';
import { useUpdatePassword } from '@/hooks/api/0130_update_password';
import { toastSuccess } from '@/lib/toast';
import { useLoading } from '@/providers/LoadingProvider';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

type FormInputs = {
  password: string;
  password_confirmation: string;
};

export const EditPassword = () => {
  const { mutate, isPending, isSuccess, error } = useUpdatePassword();
  const { setShowLoading } = useLoading();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onBlur',
    criteriaMode: 'all',
  });

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (isSuccess) {
      toastSuccess('パスワードを変更しました。再度サインインをお願いいたします。');
      navigate(`/sign_in`);
    }
  }, [isSuccess]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  return (
    <HomeLayout>
      <main className="main-content mt-0">
        <div
          className="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <span className="mask bg-gradient-dark opacity-5"></span>
        </div>
        <div className="container">
          <div className="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
            <MyProfileMenuButtonGroup />

            <div className="col-lg-5 col-md-7">
              <div className="card">
                <div className="card-header text-center pt-4 pb-1">
                  <h4 className="font-weight-bolder mb-0">パスワード変更</h4>
                </div>
                <div className="card-body">
                  <form role="form" onSubmit={handleSubmit(onSubmit)}>
                    <ApiErrorMessages error={error} />

                    <div className="mb-3">
                      <input
                        type="password"
                        maxLength={50}
                        className={`form-control ${errors.password && 'is-invalid'}`}
                        placeholder={'新しいパスワード'}
                        aria-label="新しいパスワード"
                        {...register('password', {
                          required: '入力して下さい。',
                          pattern: {
                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[!-~]{8,50}$/,
                            message: '半角英数・大文字小文字・記号を組み合わせて下さい。',
                          },
                        })}
                      />
                      {errors.password && <div className="text-xs text-danger mt-1">{errors.password.message}</div>}
                    </div>
                    <div className="mb-3">
                      <input
                        type="password"
                        maxLength={50}
                        className={`form-control ${errors.password_confirmation && 'is-invalid'}`}
                        placeholder={'新しいパスワード再入力'}
                        aria-label="新しいパスワード再入力"
                        {...register('password_confirmation', {
                          required: '入力して下さい。',
                          validate: (value) => value == getValues('password') || 'パスワードが一致しません。',
                        })}
                      />
                      {errors.password_confirmation && (
                        <div className="text-xs text-danger mt-1">{errors.password_confirmation.message}</div>
                      )}
                    </div>
                    <div className="text-center mb-3">
                      <button className="btn bg-gradient-dark btn-lg w-100">設定する</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </HomeLayout>
  );
};
